import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import TablePaging from "./TablePaging";
import EntryTable from "./table/EntryTable";
import { useCollectiveEntryFormKeyHandler } from "../../hooks/useCollectiveEntryFormKeyHandler";

const ROW_NUMBER_PER_PAGE = 20;

const filterProducts = (products, page) => {
  return products.slice(
    ROW_NUMBER_PER_PAGE * (page - 1),
    ROW_NUMBER_PER_PAGE * page
  )
}


export default function EntryTablePart({products, control}) {

  const maxPage = Math.max(Math.ceil(products.length / ROW_NUMBER_PER_PAGE), 1);

  const handleClickUpdateSalesRecordAndPrintQr = (_e) => {
    control.submitAndPrintQr();
  }

  const handleClickSubmit = (_e) => {
    control.submit();
  }
  
  const keyHandler = useCollectiveEntryFormKeyHandler(control.page, maxPage, control.changePage);

  return (
    <Box>
      <Stack spacing={1}>
        <Grid container spacing={2}  mb={2} justifyContent="end" alignItems="center">
          <Grid item xs='auto'>
            <Typography>
              ※送り状Noと仕切Noは、入力しない場合自動で連番設定します。
            </Typography>
          </Grid>
          <Grid item xs='auto'>
            <Button
              variant="contained"
              onClick={handleClickSubmit}
              disabled={control.disabledSubmit}
            >
              販売原票確定
            </Button>
          </Grid>
          <Grid item xs='auto'>
            <Button
              variant="contained"
              onClick={handleClickUpdateSalesRecordAndPrintQr}
              disabled={control.disabledSubmit}
            >
              販売原票確定 / QR発行
            </Button>
          </Grid>
        </Grid>
        <EntryTable
          products={filterProducts(products, control.page)}
          control={control}
          keyHandler={keyHandler}
        />
        <TablePaging
          maxPage={maxPage}
          page={control.page}
          changePage={control.changePage}
        />
      </Stack>
    </Box>
  )

}
